module.exports = __webpack_public_path__ + "static/media/oslo.ccafe7a1.jpg";